import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSection,
  PodFooter,
  ProductPod,
  ProductImage,
  ProductRating,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import {
  bool as boolType,
  string as stringType,
  number as numType
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { Row, Col } from '@thd-olt-component-react/core-ui';

export const SupplementalProductPodV7 = (props) => {
  const {
    itemId,
    storeId,
    position,
    parent,
    hideATC,
    scheme
  } = props;

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent, position, scheme }}
      render={(pod) => (
        <>
          <PodSection noPadding>
            <Row>
              <Col xs={4} fallback={4}>
                <ProductImage
                  itemId={pod.itemId}
                />
              </Col>
              <Col xs={8} fallback={8}>
                <PodSection noPadding columnAlign>
                  <ProductHeader
                    brand="above"
                    itemId={pod.itemId}
                    brandTitleMaxLine={4}
                    disableShopThisCollection
                  />
                  <ProductRating itemId={pod.itemId} />
                  <Price
                    itemId={pod.itemId}
                    large={false}
                    storeId={storeId}
                    displayEachUom={false}
                    hideSavingsText
                  />
                  {!hideATC && (
                    <PodFooter noPadding>
                      <ProductATC
                        itemId={pod.itemId}
                        checkGeneric
                        outline
                      />
                    </PodFooter>
                  )}
                </PodSection>
              </Col>
            </Row>
          </PodSection>

        </>
      )}
    />
  );
};

SupplementalProductPodV7.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductRating,
  ProductATC,
  Price,
  ProductHeader,
);

SupplementalProductPodV7.propTypes = {
  itemId: stringType.isRequired,
  storeId: stringType,
  position: numType,
  parent: stringType,
  hideATC: boolType,
  scheme: stringType.isRequired
};

SupplementalProductPodV7.defaultProps = {
  storeId: '',
  position: null,
  parent: '',
  hideATC: false
};
SupplementalProductPodV7.displayName = 'SupplementalProductPodV7';